import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const MicOnIcon = (props: SvgIconProps) => (
  <SvgIcon
    component="svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      opacity="0.2"
      d="M18.375 7C18.375 4.58375 16.4162 2.625 14 2.625C11.5838 2.625 9.625 4.58375 9.625 7V14C9.625 16.4162 11.5838 18.375 14 18.375C16.4162 18.375 18.375 16.4162 18.375 14V7Z"
      fill="white"
    />
    <path
      d="M18.375 7C18.375 4.58375 16.4162 2.625 14 2.625C11.5838 2.625 9.625 4.58375 9.625 7V14C9.625 16.4162 11.5838 18.375 14 18.375C16.4162 18.375 18.375 16.4162 18.375 14V7Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 21.875V25.375"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.8305 14.875C21.6035 16.7925 20.6808 18.5602 19.2374 19.8428C17.794 21.1254 15.9302 21.8338 13.9992 21.8338C12.0683 21.8338 10.2045 21.1254 8.76105 19.8428C7.31764 18.5602 6.39498 16.7925 6.16797 14.875"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
